import styled from "@emotion/styled";
import ReactPaginate from "react-paginate";

export interface PageChangeType {
  selected: number;
}

interface PaginatorProps {
  pageCount: number;
  onPageChange: (selected: PageChangeType) => void;
  pageNo: number;
  pageSize?: number;
  onSizeChange?: (size: string) => void;
}

const Paginator = (props: PaginatorProps) => {
  const { pageCount, onPageChange, pageNo, pageSize, onSizeChange } = props;

  return (
    <Paginator.Wrapper>
      <ReactPaginate
        previousLabel={"<"}
        nextLabel={">"}
        previousClassName="pagination-prev-btn"
        pageCount={pageCount}
        onPageChange={onPageChange}
        forcePage={pageNo}
        containerClassName={"pagination-container"}
        disabledClassName={"paginationDisabled"}
        activeClassName={"paginationActive"}
        pageRangeDisplayed={2}
        marginPagesDisplayed={2}
      />
      {onSizeChange != null && (
        <div className="select-holder">
          <select
            onChange={(value) => {
              onSizeChange(value.target.value);
            }}
            value={String(pageSize)}
          >
            <option value="5">5 / page</option>
            <option value="10">10 / page</option>
            <option value="25">25 / page</option>
            <option value="50">50 / page</option>
            <option value="100">100 / page</option>
          </select>
        </div>
      )}
    </Paginator.Wrapper>
  );
};
Paginator.Wrapper = styled.div`
  .pagination-container {
    margin-top: 1rem;
    height: 40px;
    list-style: none;
    display: flex;
    justify-content: center;
  }

  .pagination-container a {
    margin: 0 2px 8px;
    border-radius: 6px;
    color: #2e68c0;
    cursor: pointer;
    font-size: 14px;
    padding: 4px 8px;
    height: 24px;
  }

  .pagination-container a:hover {
    color: white;
    background-color: #2e68c0;
  }

  .paginationActive a {
    color: white;
    background-color: #2e68c0;
  }

  .paginationDisabled a {
    opacity: 0.3;
    cursor: not-allowed;
    pointer-events: none;
    background-color: transparent;
  }
  .select-holder {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
    select {
      padding-left: 10px;
      text-align: center;
      background-color: #fff;
      height: 40px;
      border: 1px solid #ccc;
      border-radius: 5px;
    }
  }
`;
export default Paginator;
